import { render } from "./OwnedTableRow.vue?vue&type=template&id=ec8cc30e&scoped=true"
import script from "./OwnedTableRow.vue?vue&type=script&lang=js"
export * from "./OwnedTableRow.vue?vue&type=script&lang=js"

import "./OwnedTableRow.vue?vue&type=style&index=0&id=ec8cc30e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8cc30e"]])

export default __exports__